import {
  Box,
  Paper,
  styled,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import TableRowContainer from './TableRowContainer'
import { style } from './SheetStyles'
import {
  StyledTableCell,
  StyledTableCellEmp,
  StyledTableCellProjectName,
} from '../Common/CommonStyles'
import EditPlanForTheDay from './EditPlanForTheDay'
import { useState } from 'react'
import CommonTableContainer from './AssignedTasks/table/CommonTableContainer'

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  left: '160px',
  width: '1719px',
  height: '60px',
  boxShadow: '0px 10px 3px #6c6c6c10',
  opacity: '1',
}))

// selectedTab

const TableLayout = (props: any) => {
  const { rowsToDisplay, onRowClick, selectedTab, mandateType } = props
  const [isNewPlanDialogOpen, setNewPlanDialog] = useState(false)
  const [getPfpId, setPfpId] = useState()
  const [getpfpIdForMngEditId, setPfpIdForMngEdit] = useState({ sender: '', cc: '' })

  let statusType = new Map<number, string>()
  mandateType?.data?.forEach((mandate: { id: number; mandate_name: string }) => {
    statusType.set(mandate.id, mandate.mandate_name)
  })

  const handleCloseNewPlanDialog = () => {
    setNewPlanDialog(false)
  }

  const handleGetpfpIdForMngEdit = (data: any) => {
    setPfpIdForMngEdit(data)
  }

  return (
    <Box overflow='scroll' width='100%' margin='20px  0px' sx={style.table}>
      <TableContainer component={Paper} id='export' sx={style.tableContainer}>
        <Table>
          <TableHead id='head'>
            <StyledTableRow sx={style.border}>
              <StyledTableCellEmp>EMP NAME</StyledTableCellEmp>

              <StyledTableCell sx={style.tableHeadWidth}>SUBJECT</StyledTableCell>
              <StyledTableCellProjectName>PROJECT NAME</StyledTableCellProjectName>
              <StyledTableCell sx={style.tableHeadWidth}>TYPE</StyledTableCell>

              {selectedTab === 1 ? (
                <>
                  <StyledTableCell sx={style.tableHeadWidth}>TIME SPENT</StyledTableCell>
                  <StyledTableCell sx={style.tableHeadWidth}>SUBMITED AT</StyledTableCell>
                  <StyledTableCell sx={style.tableHeadWidth}>COMMENT</StyledTableCell>
                </>
              ) : (
                <>
                  <StyledTableCell sx={style.tableHeadWidth}>EST TIME</StyledTableCell>
                  <StyledTableCell
                    sx={{
                      width: '80px',
                      textAlign: 'center',
                    }}
                  >
                    <Box display={'flex'} justifyContent={'center'}>
                      STATUS
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell sx={style.tableHeadWidth}>UPDATED AT</StyledTableCell>
                  <StyledTableCell sx={{ width: '80px' }}>COMMENT</StyledTableCell>
                  <StyledTableCell
                    sx={{
                      width: '80px',
                    }}
                  >
                    EDIT
                  </StyledTableCell>
                </>
              )}
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {rowsToDisplay?.map((row: any, idx: any) => (
              <TableRowContainer
                setNewPlanDialog={setNewPlanDialog}
                isNewPlanDialogOpen={isNewPlanDialogOpen}
                getPfpId={getPfpId}
                setPfpId={setPfpId}
                selectedTab={selectedTab}
                statusType={statusType}
                key={idx}
                row={row}
                idx={idx}
                onRowClick={onRowClick}
                handleGetpfpIdForMngEdit={handleGetpfpIdForMngEdit}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <EditPlanForTheDay
        getpfpIdForMngEdit={getpfpIdForMngEditId}
        setPfpId={setPfpId}
        getPfpId={getPfpId}
        isNewPlanDialogOpen={isNewPlanDialogOpen}
        setNewPlanDialog={setNewPlanDialog}
        onClose={handleCloseNewPlanDialog}
      />
    </Box>
  )
}

export default TableLayout
